import React, { Component } from 'react'
import { func, object } from 'prop-types'
import { translate } from 'react-i18next'
import { withRouter } from 'react-router'
import { PagesPaths } from '../../constants/Pages'
import { Loader } from '../../components/ui/states/Loader'
import api from '../../api'

/**
 * Special page - link is sent by email to gardeners for them
 * to disable them from the platform for a month.
 */
class GardenerDisponibilityPageComponent extends Component {
  constructor () {
    super()
    this.state = {
      loading: false,
      error: false,
      success: false
    }
  }

  get params () {
    const { match } = this.props
    return { secret: match.params.secret, token: match.params.token }
  }

  async componentDidMount () {
    const { history } = this.props
    const params = this.params
    if (!params.secret || !params.token) {
      history.replace(PagesPaths.SIGNIN.path)
    }
    this.setState({ loading: true })
    try {
      const response = await api.gardeners.unavailability(params)
      this.setState({ ...response, loading: false, success: true })
    } catch (e) {
      return this.setState({ error: true, loading: false })
    }
  }

  render () {
    const { t } = this.props
    return (
      <div className='layout__container home__container--padding'>
        <div className='boxed__container centered--container'>
          <div className='signin__title'>
            <h1>{t('common:gardenersDisponibilities:title')}</h1>
          </div>
          {
            this.state.loading
            ? (
              <div>
                <p>{t('common:gardenersDisponibilities:updating')}</p>
                <Loader size='small' style={{ marginTop: '33px' }} />
              </div>
            ) : ''
          }
          {
            this.state.success
            ? (
              <div>
                <p>{t('common:gardenersDisponibilities:success_title', { name: this.state.firstName })}</p>
                <p>{t('common:gardenersDisponibilities:success_text', { date: this.state.resetDate })}</p>
                <p>{t('common:gardenersDisponibilities:success_thanks')}</p>
              </div>
            ) : ''
          }
          {
            this.state.error
            ? (
              <div>
                <p>{t('common:gardenersDisponibilities:error')}</p>
                <p>{t('common:gardenersDisponibilities:thanks')}</p>
              </div>
            ) : ''
          }
        </div>
      </div>
    )
  }
}

GardenerDisponibilityPageComponent.propTypes = {
  t: func,
  match: object
}

export const GardenerDisponibilityPage = withRouter(translate()(GardenerDisponibilityPageComponent))



// WEBPACK FOOTER //
// ./src/pages/disponibilite/GardenerDisponibilityPage.js